import { isEmpty } from 'lodash'

import {
  useListenPublishedCheckoutPageQuery,
  useListenPublishedSalesPageQuery,
} from 'modules/PageBuilder/pageBuilderApi'
import {
  useListenOneTimeProductsQuery,
  useListenProductPricingQuery,
  useListenStripeProductNameQuery,
} from 'modules/ProductInfo/productInfoApi'
import { getMembershipName, getSellableProducts } from 'modules/Reports/reportsUtils'

const isQueryLoading = (data) => data === undefined || data?.isLoading
const getLoadedData = (data) => (isQueryLoading(data) ? null : data)

// The products a coach can send people to, each with its storefront path. Shared by the
// Reports link builder and the Share page so both offer the same products.
export function useSellableProducts({ coachOrgId }) {
  const skip = !coachOrgId
  const { data: plansData } = useListenProductPricingQuery({ coachOrgId }, { skip })
  const { data: checkoutPageData } = useListenPublishedCheckoutPageQuery({ coachOrgId }, { skip })
  const { data: salesPageData } = useListenPublishedSalesPageQuery({ coachOrgId }, { skip })
  const { data: oneTimeProductsData } = useListenOneTimeProductsQuery({ coachOrgId }, { skip })
  const { data: stripeProductNameData } = useListenStripeProductNameQuery({ coachOrgId }, { skip })
  const isLoading = [plansData, checkoutPageData, salesPageData, oneTimeProductsData, stripeProductNameData].some(
    isQueryLoading
  )
  const subscriptionName = getLoadedData(stripeProductNameData)
  const products = isLoading
    ? []
    : getSellableProducts({
        subscriptionName,
        subscriptionPlans: plansData,
        subscriptionCheckoutPage: checkoutPageData,
        subscriptionSalesPage: salesPageData,
        oneTimeProducts: oneTimeProductsData,
      })
  // Any subscription plan or one-time product, ready for sale or not.
  const hasAnyProduct = !isLoading && (!isEmpty(plansData) || !isEmpty(oneTimeProductsData))
  return { products, hasAnyProduct, membershipName: getMembershipName(subscriptionName), isLoading }
}
